import api from "../services/api";

// Fetch all package plans
export const fetchPlans = async () => {
  try {
    const response = await api.get("/kilometer-package-management/packages");

    if (response.status === 200) {
      return { success: true, data: response.data };
    } else {
      console.warn("Unexpected response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching plans:", error.message || error);
    return { success: false, error: error.message || "Failed to fetch plans" };
  }
};

// Create a new package plan
export const createPlan = async (payload) => {
  try {
    const response = await api.post("/kilometer-package-management/packages/create", payload);

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      console.warn("Unexpected response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error creating plan:", error.message || error);
    return { success: false, error: error.message || "Failed to create plan" };
  }
};

// Update an existing package plan
export const updatePlan = async (id, payload) => {
  try {
    const response = await api.put(`/kilometer-package-management/packages/${id}`, payload);

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      console.warn("Unexpected response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error updating plan:", error.message || error);
    return { success: false, error: error.message || "Failed to update plan" };
  }
};

// Delete a package plan
export const deletePlan = async (id) => {
  try {
    const response = await api.delete(`/kilometer-package-management/packages/${id}`);

    if (response.status === 200) {
      return { success: true, message: "Plan deleted successfully" };
    } else {
      console.warn("Unexpected response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error deleting plan:", error.message || error);
    return { success: false, error: error.message || "Failed to delete plan" };
  }
};
